module.exports = __webpack_public_path__ + "static/media/2.82087e13.png";